import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './TitledSidebar.module.css';

const bindClasses = classNameBind.bind(styles);

const TitledSidebar = ({ children, formElements }) => (
  <div
    className={bindClasses('wrapper')}
    data-ppuc-id="TitledSidebar"
  >
    <div className={bindClasses('form-content')}>{formElements}</div>
    <div className={bindClasses('list-content')}>{children}</div>
  </div>
);

TitledSidebar.defaultProps = {
  children: null,
  formElements: null,
};

export default TitledSidebar;
